import _ from "lodash";
import React, { useEffect, useState, useContext } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import { exportToExcel } from "utils/AppUtils";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import StoreContext from "contexts/StoreContext";
import HippoTable from "components/ReactTable/HipposReactTable";
import StatusColumn from "components/Custom/StatusColumn";
import FreePriceColumn from "components/Custom/FreePriceColumn";
import TimestampColumn from "components/Custom/TimestampColumn";
import ColorColumn from "components/Custom/ColorColumn";
import EditButton from "views/Components/EditButton";
import ExportToExcelButton from "views/Components/ExportToExcelButton";
import ImportCsvButton from "views/Components/ImportCsvButton";
import ImportCsvModal from "components/Modals/ImportCsvModal";
import ExtraOrderModal from "components/Modals/ExtraOrderModal";
import CopyExtraCategoryModal from "components/Modals/CopyExtraCategoryModal";
import ShowModalButton from "views/Components/ShowModalButton";
import moment from "moment";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function CategoryExtraListPage() {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [alert, setAlert] = useState(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [extraCategoryId, setExtraCategoryId] = useState(null);
  const [showOrderEdit, setShowOrderEdit] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showImport, setShowImport] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [copyExtraCategory, setCopyExtraCategory] = useState({ id: null, name: "" });

  const handleCloseOrderEdit = () => setShowOrderEdit(false);

  const handleShowCopy = (extraCategory) => {
    setCopyExtraCategory({ id: extraCategory.id, name: extraCategory.name });
    setShowCopy(true);
  };

  const handleShowOrderEdit = (id) => {
    setExtraCategoryId(id);
    setShowOrderEdit(true);
  };

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 70,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.designation"),
      accessor: "name",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.position"),
      accessor: "order",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.singleChoice"),
      accessor: "singleChoice",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.color"),
      accessor: "colorComponent",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "edit",
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
  ];

  const fetchData = async () => {
    try {
      setShowLoader(true);
      const dataResponse = await apiService.get(`api/v1/extra-categories/store/${storeId}`);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.status = <StatusColumn value={el.deleted} />;
      el.colorComponent = <ColorColumn color={el.color} />;
      el.singleChoice = <FreePriceColumn value={el.singleChoice} />;
      el.timestamp = <TimestampColumn timestamp={el.updatedAt} />;
      el.edit = (
        <div>
          <ShowModalButton handler={() => handleShowOrderEdit(el.id)} variant="info" icon="fa fa-list" className="text-info btn-link" title={t("pages.titles.editExtraOrder")} />
          <ShowModalButton handler={() => handleShowCopy(el)} variant="warning" icon="fa fa-copy" className="text-warning btn-link" title={t("pages.titles.copyExtraCategory")} />
          <EditButton uri={`/admin/extra-category/${el.id}`} />
        </div>
      );
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  const formatData = (data) => {
    const formattedData = data.map((extraCat) => {
      return {
        ID: extraCat.id,
        [t("tables.headers.designation")]: extraCat.name,
        [t("tables.headers.position")]: extraCat.order,
        [t("tables.headers.singleChoice")]: extraCat.singleChoice ? "NAI" : "OXI",
        [t("tables.headers.updatedAt")]: moment(extraCat.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
        [t("tables.headers.color")]: extraCat.color,
        [t("tables.headers.deleted")]: extraCat.deleted ? "NAI" : "OXI",
        [t("tables.headers.deletedAt")]: extraCat.deletedAt ? moment(extraCat.deletedAt).format("DD/MM/YYYY HH:mm:ss") : null,
      };
    });
    return formattedData;
  };

  const handleExportData = async () => {
    try {
      setExcelLoading(true);
      const dataResponse = await apiService.get(`api/v1/extra-categories/store/${storeId}`);
      exportToExcel(formatData(dataResponse), `extra_categories_${moment().format("YYYYMMDD")}`, t("messages.storeExtraCategories"));
      setExcelLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId]);

  return (
    <>
      {alert}
      <ExtraOrderModal extraCategoryId={extraCategoryId} show={showOrderEdit} handleClose={handleCloseOrderEdit} />
      <CopyExtraCategoryModal extraCategoryId={copyExtraCategory.id} extraCategoryName={copyExtraCategory.name} show={showCopy} handleClose={() => setShowCopy(false)} />
      <ImportCsvModal type="extra-categories" title={t("pages.titles.importExtraCategories")} show={showImport} handleClose={() => setShowImport(false)} onImported={fetchData} />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row className="mx-1">
                  <CreateTableBtn route={"/admin/extra-category"} />
                  <ExportToExcelButton handler={handleExportData} disabled={excelLoading} />
                  <ImportCsvButton handler={() => setShowImport(true)} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CategoryExtraListPage;
